import { render, staticRenderFns } from "./ReservationInfo.vue?vue&type=template&id=31e2b2c0&scoped=true"
import script from "./ReservationInfo.vue?vue&type=script&lang=js"
export * from "./ReservationInfo.vue?vue&type=script&lang=js"
import style0 from "./ReservationInfo.vue?vue&type=style&index=0&id=31e2b2c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e2b2c0",
  null
  
)

export default component.exports